import { SelectOption } from '../models';

export const truckDefects = [
  'Air Compressor',
  'Air Lines',
  'Battery',
  'Belts and Hoses',
  'Body',
  'Brake Accessories',
  'Brakes, Parking',
  'Brakes, Service',
  'Clutch',
  'Coupling Devices',
  'Defroster/Heater',
  'Drive Line',
  'Engine',
  'Exhaust',
  'Filth Wheel',
  'Fluid Levels',
  'Frame and Assembly',
  'Front Axle',
  'Fuel Tanks',
  'Generator',
  'Horn',
  'Lights',
  'Mirrors',
  'Muffler',
  'Oil Level',
  'Radiator Level',
  'Rear End',
  'Reflectors',
  'Safety Equipment',
  'Starter',
  'Steering',
  'Suspension System',
  'Tire Chains',
  'Tires',
  'Transmission',
  'Trip Recorder',
  'Wheels and Rims',
  'Windows',
  'Windshield Wipers',
  'Other',
];

export const TruckDefectsOptions: SelectOption[] = truckDefects.map((defect: string) => {
  return {
    label: defect,
    value: defect,
  };
});
